<mpro-loading *ngIf="isLoading"></mpro-loading>
<mpro-map-header *ngIf="!isCategories" [showCountriesOutsideRegion]="showCountriesOutsideRegion" [selectedYear]="dataFilters.year"
  (mapHeaderDataChanged)="onMapHeaderChanged($event)">
</mpro-map-header>
<mpro-map-header-categories *ngIf="isCategories" [showCountriesOutsideRegion]="showCountriesOutsideRegion" [selectedYear]="dataFilters.year"
                 (mapHeaderDataChanged)="onMapHeaderChanged($event)">
</mpro-map-header-categories>
<mpro-tags></mpro-tags>

<div id="map">
  <div class="legend-collapsed pointer mpro-box" style="display: flex;" *ngIf="!expandLegend"
    (click)="expandLegend = !expandLegend">
    Map Key <div class="right-arrow"></div>
  </div>
  <div class="legend-expanded mpro-box" *ngIf="expandLegend">
    <div style="display: flex;" class="pointer" (click)="expandLegend = !expandLegend">
      <div class="left-arrow"></div> Map Key
    </div>
    <div *ngFor="let c of legendColors.get(spendingGroupColor); let i = index" class="legend-color-box-wrapper">
      <div [style.background-color]="getCssColor(c)" class="legend-color-box">
      </div>
      {{ legend[i].legendLabel }}
    </div>
  </div>
</div>

<div class="map-buttons">
  <div class="map-button" *ngIf="openToolSelection">
    <span class="arrow-button" (click)="backToWorldwideView()">
      <svg-icon key="back-blue"></svg-icon>
      <span>Back to worldwide view</span>
    </span>
  </div>
  <div class="map-button" *ngIf="semiSelectedMode">
    <span class="arrow-button" (click)="backToSelectedRegion()">
      <svg-icon key="back-blue"></svg-icon>
      <span>Back to selected region</span>
    </span>
  </div>
  <div class="map-button" [ngStyle]="{opacity: currentSelection.countries.size < 2 ? 0.6 : 1}"
    *ngIf="!dataFilters.dataLens && authService.isLoggedIn()">
    <mpro-toggle-switch label="Show countries outside of selected region" [state]="showCountriesOutsideRegion"
      (stateChange)="onShowCountriesOutsideRegionChange($event)" [disabled]="currentSelection.countries.size < 2">
    </mpro-toggle-switch>
  </div>
</div>

<div #tooltip [hidden]="true">
  <mpro-tooltip [options]="mapTooltip"></mpro-tooltip>
</div>
